import axios from 'axios';
import { addIPToRequest } from './ipUtils';

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true,
  timeout: 10000
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add client IP to request headers
    await addIPToRequest(config);
    
    // Prevent caching for all GET requests to ensure fresh data
    if (config.method && config.method.toLowerCase() === 'get') {
      config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      config.headers['Pragma'] = 'no-cache';
      config.headers['Expires'] = '0';
      
      // Add timestamp to prevent browser caching
      if (!config.params) {
        config.params = {};
      }
      config.params._t = new Date().getTime();
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Simple retry with backoff for transient errors
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config || {};
    const status = error.response?.status;

    if (!config.__retryCount) config.__retryCount = 0;

    const shouldRetry = (
      error.code === 'ECONNABORTED' || // timeout
      !error.response || // network error
      status === 429 ||
      (status && status >= 500)
    );

    if (shouldRetry && config.__retryCount < 2) {
      config.__retryCount += 1;
      const delay = 500 * Math.pow(2, config.__retryCount - 1); // 500ms, 1000ms
      await new Promise((r) => setTimeout(r, delay));
      return axiosInstance(config);
    }

    if (status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('token');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default axiosInstance; 